import { motion } from "framer-motion";
import styles from "Styles/Background/backgroundContainer.module.css";
import useSegment from "Hooks/useSegment";
import React from "react";
import useWindowSize from "Hooks/useWindowSize";

const BackgroundHorseshoe = () => {
  const { width } = useWindowSize();
  console.log("Width : ", width);
  return (
    <motion.svg
      className={styles.backgroundElement}
      style={{
        top: "-100px",
        right: "20vw",
        scale: width > 768 ? [1, 1] : [0.5, 0.5],
        zIndex: 5,
      }}
      animate={{
        x: -200,
        y: 100,
        rotate: 180,
      }}
      transition={{
        duration: 60,
        repeat: Infinity,
        repeatType: "mirror",
        type: "tween",
      }}
      width="356"
      height="342"
      viewBox="0 0 356 342"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_112_226)">
        <path
          d="M189.574 272.971C268.122 251.738 314.556 170.852 293.299 92.2939L206.64 115.717C214.942 146.403 196.801 177.992 166.121 186.284C135.457 194.572 103.857 176.431 95.5544 145.744L8.88521 169.166C30.147 247.73 111.043 294.201 189.574 272.971Z"
          fill="#FD8A8A"
        />
      </g>
      <defs>
        <clipPath id="clip0_112_226">
          <rect
            width="288.507"
            height="208.749"
            fill="white"
            transform="translate(0 176.006) rotate(-37.5937)"
          />
        </clipPath>
      </defs>
    </motion.svg>
  );
};

const BackgroundStar = () => {
  const { width } = useWindowSize();

  return (
    <motion.svg
      style={{
        bottom: width > 768 ? "200px" : "20px",
        right: width > 768 ? "550px" : "-50px",
        scale: width > 768 ? [2, 2] : [1.5, 1.5],
        zIndex: 5,
      }}
      animate={{
        x: 0,
        y: 0,
        rotate: -360,
      }}
      transition={{
        duration: 30,
        repeat: Infinity,
        repeatType: "mirror",
      }}
      className={styles.backgroundElement}
      width="133"
      height="133"
      viewBox="0 0 133 133"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_112_208)">
        <path
          d="M91.8236 90.1076L104.098 90.8L99.1445 79.5391L110.935 75.9839L102.431 67.1127L112.313 59.7355L101.281 54.3284L108.059 44.0196L95.8309 42.7221L98.693 30.7254L86.747 33.7008L85.3423 21.4622L75.1134 28.3486L69.6186 17.3441L62.3423 27.3108L53.4134 18.8693L49.9718 30.7159L38.6882 25.8565L39.4913 38.15L27.2138 37.4556L32.1672 48.7165L20.3763 52.2717L28.8807 61.1429L19.0018 68.522L30.0338 73.9292L23.2563 84.238L35.4808 85.5335L32.622 97.5322L44.568 94.5568L45.9727 106.795L56.1983 99.907L61.6964 110.914L68.9694 100.945L77.8983 109.386L81.3431 97.5417L92.6268 102.401L91.8236 90.1076Z"
          fill="#FCCA23"
        />
      </g>
      <defs>
        <clipPath id="clip0_112_208">
          <rect
            width="96.3363"
            height="96.3363"
            fill="white"
            transform="translate(49.8867) rotate(31.1877)"
          />
        </clipPath>
      </defs>
    </motion.svg>
  );
};

const BackgroundGridLines = () => {
  return <div className={styles.backgroundGridLines}></div>;
};

const BackgroundGravityBall = () => {
  return (
    <motion.svg
      className={`${styles.backgroundElement} ${styles.backgroundGravityBall}`}
      transition={{
        y: {
          duration: 0.4,
          yoyo: Infinity,
          ease: "easeOut",
        },
      }}
      animate={{
        y: ["5px", "0px"],
      }}
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M62.2407 62.2421C76.4794 48.0034 76.4794 24.918 62.2407 10.6793C48.002 -3.55938 24.9166 -3.55938 10.6779 10.6793C-3.56079 24.918 -3.56079 48.0034 10.6779 62.2421C24.9166 76.4808 48.002 76.4808 62.2407 62.2421Z"
        fill="white"
      />
    </motion.svg>
  );
};

const NameSuccessBackground = () => {
  // const isFullWidth = backgroundStyle === "fullwidth";
  const segment = useSegment();
  const isNameSuccessPage = () => {
    return segment === "name-success";
  };

  const bgElements = {
    nameSuccessPage: [
      {
        element: isNameSuccessPage() ? BackgroundHorseshoe : null,
        key: "horseshoe",
      },
      {
        element: isNameSuccessPage() ? BackgroundStar : null,
        key: "star",
      },
      {
        element: isNameSuccessPage() ? BackgroundGridLines : null,
        key: "grid",
      },
      {
        element: isNameSuccessPage() ? BackgroundGravityBall : null,
        key: "ball",
      },
    ],
  };

  return (
    <>
      {bgElements.nameSuccessPage
        .filter((j) => j.element)
        .map((el, i) =>
          React.createElement(el.element, {
            key: el.key,
            // isExiting: transitionState
          }),
        )}
    </>
  );
};

export default NameSuccessBackground;
